//
// Anchor id of the single app-wide tooltip instance mounted by AppTooltip.
//
const appTooltipId = 'appTooltip';

export default appTooltipId;
